
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWaze = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  viewBox: "0 0 25 25"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "waze_59863ee332253318__a",
  width: "164%",
  height: "164%",
  x: "-32%",
  y: "-32%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.151032561 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#waze_59863ee332253318__a)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M14.096 1.724A10.069 10.069 0 0 0 6.15 5.578a9.879 9.879 0 0 0-2.09 6.077v1.84c0 .8-.314 1.563-.837 2.119-.418.417-.941.73-1.499.868.21.52.697 1.32 1.568 2.188a8.825 8.825 0 0 0 2.545 1.84v-.034a3.128 3.128 0 0 1 2.648-1.424c.21 0 .383.035.593.069a3.125 3.125 0 0 1 2.474 2.43h2.579c2.683 0 5.227-1.11 7.075-2.916 2.857-2.847 3.728-7.119 2.16-10.8-1.568-3.715-5.193-6.11-9.27-6.11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M13.766 0c-3.433 0-6.657 1.536-8.842 4.294a11.274 11.274 0 0 0-2.392 6.984v1.815c0 .943-.659 1.816-1.942 1.886-.312 0-.555.244-.589.558-.035.839.867 2.41 2.115 3.667.867.873 1.872 1.571 2.947 2.13C4.716 23.254 6.207 25 8.149 25h.034a3.125 3.125 0 0 0 3.052-2.48h2.6c.277 1.433 1.526 2.48 3.052 2.48.346 0 .727-.07 1.074-.174.867-.28 1.526-.943 1.838-1.817a3.391 3.391 0 0 0 0-2.269 11.501 11.501 0 0 0 1.907-1.536A11.162 11.162 0 0 0 25 11.278c0-3.003-1.179-5.797-3.294-7.926C19.591 1.152 16.748 0 13.766 0zm0 1.257c4.022 0 7.663 2.444 9.223 6.18a9.931 9.931 0 0 1-2.15 10.86 9.935 9.935 0 0 1-7.039 2.932h-2.565c-.243-1.257-1.214-2.2-2.462-2.444-.208-.035-.381-.07-.59-.07-1.04 0-2.045.524-2.634 1.432v.035a11.028 11.028 0 0 1-2.532-1.851c-.867-.873-1.352-1.711-1.56-2.2.59-.14 1.075-.454 1.49-.873.521-.593.833-1.327.833-2.13v-1.85c0-2.2.728-4.365 2.08-6.11 1.942-2.55 4.82-3.911 7.906-3.911z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M18.534 7.759c-.718 0-1.293.574-1.293 1.293 0 .718.575 1.293 1.293 1.293.719 0 1.294-.575 1.294-1.293 0-.719-.575-1.293-1.294-1.293zm-6.896 0c-.719 0-1.293.574-1.293 1.293 0 .718.574 1.293 1.293 1.293.718 0 1.293-.575 1.293-1.293 0-.719-.575-1.293-1.293-1.293zm-.649 5.172c-.468 0-.792.42-.576.806.864 1.611 2.664 2.642 4.68 2.642 2.016 0 3.816-1.03 4.68-2.642.18-.387-.108-.806-.575-.806a.65.65 0 0 0-.576.323c-.648 1.192-2.017 1.965-3.493 1.965-1.512 0-2.88-.773-3.492-1.965a.778.778 0 0 0-.648-.323z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\">\r\n    <defs>\r\n        <filter id=\"3xwi382pua\" width=\"164%\" height=\"164%\" x=\"-32%\" y=\"-32%\" filterUnits=\"objectBoundingBox\">\r\n            <feOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"1\"/>\r\n            <feColorMatrix in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.151032561 0\"/>\r\n            <feMerge>\r\n                <feMergeNode in=\"shadowMatrixOuter1\"/>\r\n                <feMergeNode in=\"SourceGraphic\"/>\r\n            </feMerge>\r\n        </filter>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g>\r\n                <g filter=\"url(#3xwi382pua)\" transform=\"translate(-42 -396) translate(17 339) translate(25 57)\">\r\n                    <path fill=\"#FFF\" d=\"M14.096 1.724c-3.102 0-5.994 1.389-7.946 3.854-1.36 1.737-2.09 3.89-2.09 6.077v1.84c0 .8-.314 1.563-.837 2.119-.418.417-.941.73-1.499.868.21.52.697 1.32 1.568 2.188.733.764 1.604 1.389 2.545 1.84v-.034c.592-.903 1.568-1.424 2.648-1.424.21 0 .383.035.593.069 1.254.243 2.23 1.216 2.474 2.43h2.579c2.683 0 5.227-1.11 7.075-2.916 2.857-2.847 3.728-7.119 2.16-10.8-1.568-3.715-5.193-6.11-9.27-6.11z\"/>\r\n                    <path fill=\"#000\" d=\"M13.766 0c-3.433 0-6.657 1.536-8.842 4.294-1.56 1.99-2.392 4.435-2.392 6.984v1.815c0 .943-.659 1.816-1.942 1.886-.312 0-.555.244-.589.558-.035.839.867 2.41 2.115 3.667.867.873 1.872 1.571 2.947 2.13C4.716 23.254 6.207 25 8.149 25h.034c1.492 0 2.74-1.047 3.052-2.48h2.6c.277 1.433 1.526 2.48 3.052 2.48.346 0 .727-.07 1.074-.174.867-.28 1.526-.943 1.838-1.817.277-.803.243-1.605 0-2.269.693-.454 1.318-.942 1.907-1.536C23.821 17.109 25 14.246 25 11.278c0-3.003-1.179-5.797-3.294-7.926C19.591 1.152 16.748 0 13.766 0zm0 1.257c4.022 0 7.663 2.444 9.223 6.18 1.56 3.736.693 8.03-2.15 10.86-1.837 1.85-4.368 2.932-7.039 2.932h-2.565c-.243-1.257-1.214-2.2-2.462-2.444-.208-.035-.381-.07-.59-.07-1.04 0-2.045.524-2.634 1.432v.035c-.937-.49-1.769-1.118-2.532-1.851-.867-.873-1.352-1.711-1.56-2.2.59-.14 1.075-.454 1.49-.873.521-.593.833-1.327.833-2.13v-1.85c0-2.2.728-4.365 2.08-6.11 1.942-2.55 4.82-3.911 7.906-3.911z\"/>\r\n                    <path fill=\"#000\" d=\"M18.534 7.759c-.718 0-1.293.574-1.293 1.293 0 .718.575 1.293 1.293 1.293.719 0 1.294-.575 1.294-1.293 0-.719-.575-1.293-1.294-1.293zM11.638 7.759c-.719 0-1.293.574-1.293 1.293 0 .718.574 1.293 1.293 1.293.718 0 1.293-.575 1.293-1.293 0-.719-.575-1.293-1.293-1.293zM10.989 12.931c-.468 0-.792.42-.576.806.864 1.611 2.664 2.642 4.68 2.642 2.016 0 3.816-1.03 4.68-2.642.18-.387-.108-.806-.575-.806-.252 0-.469.129-.576.323-.648 1.192-2.017 1.965-3.493 1.965-1.512 0-2.88-.773-3.492-1.965-.144-.194-.36-.323-.648-.323z\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/waze.59863ee332253318def733d7eb36f1cc.svg"),
        {
          React: SvgWaze,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      